import { marketSelect } from './utils'

const imagesPaths = {
    map: {
        marker: {
            normal: '/images/map/marker.svg',
            cluster: '/images/map/marker-cluster.svg',
            active: '/images/map/marker-active.svg'
        },
        radar: '/images/map/radar.svg',
        pin: '/images/map/pin.svg'
    }
}

const twicPicsDomain = marketSelect({
    france: 'https://burgerkingfrance.twic.pics',
    reunion: 'https://burgerkingreunion.twic.pics'
})

export { imagesPaths, twicPicsDomain }
